module.exports = __webpack_public_path__ + "img/icon_cards.9293ee36.svg";